import axios from "axios";
import { supabase, supabaseConfigured } from "@/lib/supabase";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Bei jedem Request: aktuelles Supabase-JWT mitschicken
api.interceptors.request.use(async (config) => {
  if (supabaseConfigured) {
    const { data } = await supabase.auth.getSession();
    const token = data?.session?.access_token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

export const fetchStats = () => api.get("/stats").then((r) => r.data);
export const fetchUsage = () => api.get("/usage").then((r) => r.data);
export const fetchMessages = (params = {}) =>
  api.get("/messages", { params }).then((r) => r.data);
export const fetchMessage = (id) =>
  api.get(`/messages/${id}`).then((r) => r.data);
export const postSimulate = (data) =>
  api.post("/messages/simulate", data).then((r) => r.data);
export const postOwnerReply = (id, reply) =>
  api.post(`/messages/${id}/owner-reply`, { reply }).then((r) => r.data);

// Conversation-Threading (gruppiert pro Sender)
export const fetchConversations = (params = {}) =>
  api.get("/conversations", { params }).then((r) => r.data);
export const fetchConversation = (id) =>
  api.get(`/conversations/${id}`).then((r) => r.data);
export const postConversationOwnerReply = (id, reply) =>
  api.post(`/conversations/${id}/owner-reply`, { reply }).then((r) => r.data);
export const archiveConversation = (id) =>
  api.post(`/conversations/${id}/archive`).then((r) => r.data);
export const unarchiveConversation = (id) =>
  api.post(`/conversations/${id}/unarchive`).then((r) => r.data);
export const markConversationUnread = (id) =>
  api.post(`/conversations/${id}/mark-unread`).then((r) => r.data);
export const markConversationRead = (id) =>
  api.post(`/conversations/${id}/mark-read`).then((r) => r.data);
export const fetchFaqs = () => api.get("/faqs").then((r) => r.data);
export const createFaq = (data) => api.post("/faqs", data).then((r) => r.data);
export const updateFaq = (id, data) =>
  api.put(`/faqs/${id}`, data).then((r) => r.data);
export const deleteFaq = (id) =>
  api.delete(`/faqs/${id}`).then((r) => r.data);
export const fetchBusinessProfile = () =>
  api.get("/business-profile").then((r) => r.data);
export const updateBusinessProfile = (data) =>
  api.put("/business-profile", data).then((r) => r.data);
export const fetchSettings = () => api.get("/settings").then((r) => r.data);
export const updateSettings = (data) =>
  api.put("/settings", data).then((r) => r.data);
export const fetchNotifications = () =>
  api.get("/notifications").then((r) => r.data);
export const markAllNotificationsRead = () =>
  api.post("/notifications/mark-all-read").then((r) => r.data);

// DSGVO Art. 15 (Auskunft) + Art. 17 (Löschung)
export const dsgvoExport = (sender_id, channel) =>
  api
    .get("/dsgvo/export", {
      params: channel && channel !== "all" ? { sender_id, channel } : { sender_id },
    })
    .then((r) => r.data);
export const dsgvoForget = (sender_id, channel) =>
  api
    .delete("/dsgvo/forget", {
      params: channel && channel !== "all" ? { sender_id, channel } : { sender_id },
    })
    .then((r) => r.data);
